import {
  ENERGY_AND_WATER_DETAIL_ROUTE_NAME,
  ENERGY_DETAIL_ROUTE_NAME,
  WASTEWATER_DETAIL_ROUTE_NAME,
  WATER_DETAIL_ROUTE_NAME
} from '@/data/routes';
import type { RoleRouteConfig } from '@/router';
import { t } from '@/locales/i18n';

export const measureDetailRoutes: RoleRouteConfig[] = [
  {
    path: '',
    name: ENERGY_AND_WATER_DETAIL_ROUTE_NAME,
    component: () => import('@/views/TechMeasureDetail/EnergyAndWaterProjectDetail'),
    meta: {
      title: t('home.techMeasureDetail')
    },
    props: ({ params }) => ({
      ...params,
      type: 'energy-water'
    })
  },
  {
    path: '',
    name: ENERGY_DETAIL_ROUTE_NAME,
    component: () => import('@/views/TechMeasureDetail/EnergyProjectDetail'),
    meta: {
      title: t('home.techMeasureDetail')
    },
    props: ({ params }) => ({
      ...params,
      type: 'energy'
    })
  },
  {
    path: '',
    name: WASTEWATER_DETAIL_ROUTE_NAME,
    component: () => import('@/views/TechMeasureDetail/WasteWaterProjectDetail'),
    meta: {
      title: t('home.techMeasureDetail')
    },
    props: ({ params }) => ({
      ...params,
      type: 'wastewater'
    })
  },
  {
    path: '',
    name: WATER_DETAIL_ROUTE_NAME,
    component: () => import('@/views/TechMeasureDetail/WaterProjectDetail'),
    meta: {
      title: t('home.techMeasureDetail')
    },
    props: ({ params }) => ({
      ...params,
      type: 'water'
    })
  }
];
